(ns frontend.view.modals.entity-esign.events
  (:require
   [common.email :as email]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.actions.attachment :as attachment-actions]
   [frontend.actions.common :as common-actions]
   [frontend.controller.websocket.event :as ws]
   [frontend.db :as db]
   [frontend.logging :as logging]
   [frontend.utils :as fu]
   [frontend.view.modals.entity-esign.sub :as sub]
   [frontend.view.entity-viewers.modules.entity-esign.event :as esign-module-event]
   [re-frame.core :as rf]))

(rf/reg-event-fx
 ::set-file
 (fn [{:keys [db] :as cofx} [_ file]]
   {:db (assoc db ::sub/file file)}))

(rf/reg-event-fx
 ::remove-file
 (fn [{:keys [db] :as cofx} [_]]
   {:db (-> db
            (assoc ::sub/file nil))}))

(rf/reg-event-fx
 ::add-signatory
 (fn [{:keys [db] :as cofx} [_]]
   {:db (-> db
            (update ::sub/signatories
                    (fn [existing]
                      (-> existing
                          (conj {})
                          (vec)))))}))

(rf/reg-event-fx
 ::remove-signatory
 (fn [{:keys [db] :as cofx} [_ i]]
   {:db (-> db
            (update ::sub/signatories
                    (fn [existing]
                      (cu/vec-remove i existing))))}))

(rf/reg-event-fx
 ::set-signatory-field
 (fn [{:keys [db] :as cofx} [_ i field value]]
   {:db (-> db
            (update ::sub/signatories
                    (fn [existing]
                      (-> existing
                          (vec)
                          (assoc-in [i field] value)
                          (vec)))))
    :fx [[:dispatch
          (case field
            :name
            [::validate-signatory-name i]
            :email
            [::validate-signatory-email i]
            nil)]]}))

(rf/reg-event-fx
 ::validate-signatory-name
 (fn [{:keys [db] :as cofx} [_ i]]
   (let [signatory (get (::sub/signatories db) i)
         error (when (fu/empty-value? (:name signatory)) (loc/tr :name-is-required))]
     {:db (-> db
              (update ::sub/signatories vec)
              (assoc-in [::sub/signatories i :errors :name] error))})))

(rf/reg-event-fx
 ::validate-signatory-email
 (fn [{:keys [db] :as cofx} [_ i]]
   (let [signatory (get (::sub/signatories db) i)
         error (cond (fu/empty-value? (:email signatory))
                     (loc/tr :email-is-required)
                     (not (email/valid-email-pattern? (:email signatory)))
                     (loc/tr :invalid-email)
                     :else nil)]
     {:db (-> db
              (update ::sub/signatories vec)
              (assoc-in [::sub/signatories i :errors :email] error))})))

(rf/reg-event-fx
 ::clear-signatories
 (fn [{:keys [db] :as cofx} [_]]
   {:db (-> db
            (assoc ::sub/signatories [{}]))}))

(rf/reg-event-fx
 ::clear-modal-data
 (fn [{:keys [db] :as _cofx} [_]]
   {:db (-> db
            (assoc ::sub/signatories [{}])
            (assoc ::sub/file nil)
            (assoc ::sub/sent-successfully? false))}))

(rf/reg-event-fx
 ::create-esign-process-failed
 (fn [{:keys [db] :as cofx} [_ on-error! resp]]
   (js/console.log "Failed to create esign process - " resp)
   (on-error! (:body resp))))

(rf/reg-event-fx
 ::create-esign-process
 (fn [{:keys [db] :as cofx} [_ entity-id on-error!]]
   (let [data {:target      entity-id
               :signatories (->> (get db ::sub/signatories)
                                 (mapv (fn [signatory]
                                         (dissoc signatory :errors))))}]
     {::ws/send {:id         :esign/create
                 :body       data
                 :on-success [::upload-attachment entity-id]
                 :on-error   [::create-esign-process-failed on-error!]}})))

(rf/reg-event-fx
 ::upload-attachment
 (fn [{:keys [db] :as cofx} [_ entity-id {:keys [body] :as resp}]]
   (let [{:keys [esign-process-id]} body
         file (::sub/file db)
         attachment {:filename    (.-name file)
                     :description nil
                     :file        file
                     :target      esign-process-id}]
     (common-actions/*<-create-op-token
      nil
      (fn [token]
        (attachment-actions/*=>add-attachment
         {:multipart-params (assoc attachment :token token)}
         (fn [resp]
           (let [attachment (-> resp
                                :body
                                (assoc :entity/type :entity.type/attachment))]
             (rf/dispatch [::send esign-process-id])
             (rf/dispatch [::clear-modal-data])
             (rf/dispatch [::esign-module-event/process-updates
                           {:entity-id entity-id
                            :entities [attachment]}])))
         (fn [e]
           (logging/error "Failed to upload attachment" e))))
      (fn [e]
        (logging/error "resp token=" e)))
     {})))

(rf/reg-event-fx
 ::send
 (fn [{:keys [db] :as cofx} [_ esign-process-id]]
   {::ws/send {:id         :esign/send
               :body       {:esign-process-id esign-process-id}
               :on-success [::sent]
               :on-error   [::send-failed]}}))


(rf/reg-event-fx
 ::sent
 (fn [{:keys [db] :as cofx} [_]]
   ((->> @db/app-state
         :new-modals
         vals
         (filter
          (fn [modal]
            (= :entity-esign-modal
               (:modal-type modal))))
         first
         :close-modal!))
   {}))


(rf/reg-event-fx
 ::send-failed
 (fn [{:keys [db] :as cofx} [_]]
   (js/console.log "Esign sending failed")
   {}))

;; V2

(rf/reg-fx
 ::v2-upload-attachment-fx
 (fn [{:keys [file entity-id esign-process-id on-success-event]}]
   (let [attachment {:filename    (.-name file)
                     :description nil
                     :file        file
                     :target      esign-process-id}]
     (common-actions/*<-create-op-token
      nil
      (fn [token]
        (attachment-actions/*=>add-attachment
         {:multipart-params (assoc attachment :token token)}
         (fn [resp]
           (let [attachment (-> resp
                                :body
                                (assoc :entity/type :entity.type/attachment))
                 attachment-id (:db/id attachment)]
             (rf/dispatch (conj on-success-event {:attachment-id attachment-id}))
             (rf/dispatch [::esign-module-event/process-updates
                           {:entity-id entity-id
                            :entities [attachment]}])))
         (fn [e]
           (logging/error "Failed to upload attachment" e))))
      (fn [e]
        (logging/error "resp token=" e))))))

(rf/reg-event-fx
 ::v2-send-success
 [rf/trim-v]
 (fn [_cofx [resp]]
   (js/console.log "V2 Send success " resp)
   {:fx [[:dispatch [::sent]]
         [:dispatch [::clear-modal-data]]]}))

(rf/reg-event-fx
 ::v2-submit-error
 [rf/trim-v]
 (fn [_cofx [resp]]
   (js/console.log "V2 submit error " resp)))

(rf/reg-event-fx
 ::v2-send
 [rf/trim-v]
 (fn [_cofx [{:keys [esign-process-id]}]]
   {::ws/send {:id :esign-v2/send
               :body {:esign-process-id esign-process-id}
               :on-success [::v2-send-success]
               :on-error [::v2-submit-error]}}))

(rf/reg-event-fx
 ::v2-create-success
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [entity-id]} resp]]
   (let [file (::sub/file db)
         esign-process-id (-> resp
                              :body
                              :esign-process-id)]
     {:fx [[::v2-upload-attachment-fx
            {:file file
             :entity-id entity-id
             :esign-process-id esign-process-id
             :on-success-event [::v2-send
                                {:esign-process-id esign-process-id}]}]]})))

(rf/reg-event-fx
 ::v2-create
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [entity-id]}]]
   (let [signatories (->> (get db ::sub/signatories)
                          (mapv (fn [signatory]
                                  (dissoc signatory :errors))))]
     {::ws/send {:id :esign-v2/create
                 :body {:target-id entity-id
                        :signatories signatories}
                 :on-success [::v2-create-success {:entity-id entity-id}]
                 :on-error [::v2-submit-error]}})))
